import React, { Component } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

import SEOHead from "../../components/seo/SEOHead";
import facebookIcon from "../../assets/img/icon_facebook.svg";
import "./Poll.css";

class PollComponent extends Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      poll: null,
      options: [],
      selectedOptionId: 0,
      voteLoading: false,
      error: "",
      results: null,
      recentVotes: [],
      totalVotes: 0,
      votesRemaining: 10,
    };
  }

  componentDidMount() {
    this.loadPoll();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.pollSlug !== this.props.pollSlug) {
      this.setState(
        {
          loading: true,
          poll: null,
          options: [],
          selectedOptionId: 0,
          error: "",
          results: null,
          recentVotes: [],
          totalVotes: 0,
          votesRemaining: 10,
        },
        this.loadPoll
      );
    }
  }

  loadPoll = () => {
    axios
      .get(window.ajaxLink + "polls/" + encodeURIComponent(this.props.pollSlug))
      .then((res) => {
        var data = res.data && res.data.responseData ? res.data.responseData : null;
        if (!data || !data.poll) {
          this.setState({ loading: false, error: "Anketa nije pronađena." });
          return;
        }

        this.setState({
          loading: false,
          poll: data.poll,
          options: data.options || [],
          error: "",
        });
      })
      .catch((err) => {
        var errorMessage =
          err.response && err.response.data && err.response.data.errorData && err.response.data.errorData.error
            ? err.response.data.errorData.error
            : "Anketa nije pronađena.";
        this.setState({ loading: false, error: errorMessage });
      });
  };

  selectOption = (optionId) => {
    if (!this.state.voteLoading) {
      this.setState({ selectedOptionId: optionId, error: "" });
    }
  };

  submitVote = (event) => {
    if (event) {
      event.preventDefault();
    }

    if (!this.state.selectedOptionId || this.state.voteLoading) {
      this.setState({ error: "Izaberite opciju za koju želite glasati." });
      return;
    }

    this.setState({ voteLoading: true, error: "" });

    axios
      .post(window.ajaxLink + "polls/" + encodeURIComponent(this.props.pollSlug) + "/vote", {
        option_id: this.state.selectedOptionId,
      })
      .then((res) => {
        var data = res.data && res.data.responseData ? res.data.responseData : null;
        if (!data) {
          this.setState({ voteLoading: false, error: "Glas trenutno nije moguće sačuvati." });
          return;
        }

        this.setState({
          voteLoading: false,
          poll: data.poll || this.state.poll,
          results: data.results || [],
          recentVotes: data.recent_votes || [],
          totalVotes: data.total_votes || 0,
          votesRemaining: data.votes_remaining,
          selectedOptionId: data.selected_option_id,
          error: "",
        });
      })
      .catch((err) => {
        var errorMessage =
          err.response && err.response.data && err.response.data.errorData && err.response.data.errorData.error
            ? err.response.data.errorData.error
            : "Glas trenutno nije moguće sačuvati. Pokušajte ponovo.";
        this.setState({ voteLoading: false, error: errorMessage });
      });
  };

  voteAgain = () => {
    if (this.state.votesRemaining > 0) {
      this.setState({ results: null, selectedOptionId: 0, error: "" });
      window.scrollTo(0, 0);
    }
  };

  sharePoll = () => {
    var pollUrl = window.location.origin + "/glasaj/" + encodeURIComponent(this.props.pollSlug);
    var facebookUrl = "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(pollUrl);

    window.open(facebookUrl, "_blank", "width=760,height=620,noopener,noreferrer");

    axios
      .post(window.ajaxLink + "polls/" + encodeURIComponent(this.props.pollSlug) + "/share", {})
      .catch(() => {});
  };

  formatTimeAgo = (dateValue) => {
    var date = new Date(dateValue);
    var diffSeconds = Math.max(0, Math.floor((new Date().getTime() - date.getTime()) / 1000));

    if (isNaN(date.getTime())) {
      return "";
    }
    if (diffSeconds < 60) {
      return "prije nekoliko sekundi";
    }
    if (diffSeconds < 3600) {
      return "prije " + Math.floor(diffSeconds / 60) + " min";
    }
    if (diffSeconds < 86400) {
      return "prije " + Math.floor(diffSeconds / 3600) + " h";
    }
    if (diffSeconds < 604800) {
      return "prije " + Math.floor(diffSeconds / 86400) + " d";
    }

    return date.toLocaleDateString("bs-BA");
  };

  renderVoteForm() {
    return (
      <form className="poll_vote_form" onSubmit={this.submitVote}>
        <div className="poll_options">
          {this.state.options.map((option) => {
            var selected = this.state.selectedOptionId == option.id;
            return (
              <label
                className={"poll_option" + (selected ? " selected" : "")}
                key={option.id}
                onClick={() => this.selectOption(option.id)}
              >
                <input
                  type="radio"
                  name="poll_option"
                  value={option.id}
                  checked={selected}
                  onChange={() => this.selectOption(option.id)}
                />
                {option.image_url ? (
                  <div className="poll_option_image_wrap">
                    <img
                      className="poll_option_image"
                      src={option.image_url}
                      alt={option.title}
                      onError={(event) => {
                        event.currentTarget.style.display = "none";
                      }}
                    />
                  </div>
                ) : null}
                <div className="poll_option_content">
                  <div className="poll_option_title">{option.title}</div>
                  {option.description ? (
                    <div className="poll_option_description">{option.description}</div>
                  ) : null}
                </div>
                <span className="poll_radio_mark"></span>
              </label>
            );
          })}
        </div>

        {this.state.error ? <div className="poll_error">{this.state.error}</div> : null}

        <button
          className="poll_vote_button"
          type="submit"
          disabled={this.state.voteLoading || !this.state.selectedOptionId}
        >
          {this.state.voteLoading ? "Čuvanje glasa..." : "Glasaj"}
        </button>
        <div className="poll_limit_note">Sa jedne IP adrese moguće je glasati najviše 10 puta.</div>
      </form>
    );
  }

  renderResults() {
    return (
      <div className="poll_results">
        <div className="poll_results_heading">Rezultati ankete</div>
        <div className="poll_total_votes">Ukupno glasova: {this.state.totalVotes}</div>

        <div className="poll_result_list">
          {this.state.results.map((option) => {
            var selected = this.state.selectedOptionId == option.id;
            return (
              <div className={"poll_result_item" + (selected ? " selected" : "")} key={option.id}>
                <div className="poll_result_top">
                  <div className="poll_result_name">
                    {option.title}
                    {selected ? <span className="poll_your_vote">Vaš glas</span> : null}
                  </div>
                  <div className="poll_result_percent">{option.percentage}%</div>
                </div>
                <div className="poll_progress_track">
                  <div className="poll_progress_value" style={{ width: option.percentage + "%" }}></div>
                </div>
                <div className="poll_result_votes">{option.votes} glasova</div>
              </div>
            );
          })}
        </div>

        {this.state.votesRemaining > 0 ? (
          <div className="poll_vote_again_wrap">
            <button className="poll_vote_again" type="button" onClick={this.voteAgain}>
              Glasaj ponovo
            </button>
            <div className="poll_votes_remaining">
              Preostalo glasova sa ove IP adrese: {this.state.votesRemaining}
            </div>
          </div>
        ) : (
          <div className="poll_votes_remaining">Iskoristili ste maksimalnih 10 glasova za ovu anketu.</div>
        )}

        <div className="poll_recent_section">
          <div className="poll_recent_title">Posljednji glasovi</div>
          <div className="poll_recent_list">
            {this.state.recentVotes.map((vote, index) => {
              var location = [vote.city, vote.country].filter(Boolean).join(", ") || "nepoznate lokacije";
              return (
                <div className="poll_recent_vote" key={index}>
                  <div className="poll_recent_text">
                    Korisnik iz <strong>{location}</strong> je glasao <strong>{vote.option_title}</strong>
                  </div>
                  <div className="poll_recent_time">{this.formatTimeAgo(vote.created_at)}</div>
                </div>
              );
            })}
          </div>
        </div>

        <button className="poll_share_button" type="button" onClick={this.sharePoll}>
          <img src={facebookIcon} alt="" />
          Podjeli Anketu
        </button>
      </div>
    );
  }

  render() {
    if (this.state.loading) {
      return <div className="poll_page"><div className="poll_loading">Učitavanje ankete...</div></div>;
    }

    if (!this.state.poll) {
      return <div className="poll_page"><div className="poll_not_found">{this.state.error || "Anketa nije pronađena."}</div></div>;
    }

    var canonicalUrl = window.location.origin + "/glasaj/" + this.state.poll.slug;

    return (
      <div className="poll_page">
        <SEOHead
          title={this.state.poll.title + " - OPK.ba"}
          description={this.state.poll.subtitle || this.state.poll.title}
          canonical={canonicalUrl}
        />
        <div className="poll_card">
          <div className="poll_badge">ANKETA</div>
          <h1 className="poll_title">{this.state.poll.title}</h1>
          {this.state.poll.subtitle ? <div className="poll_subtitle">{this.state.poll.subtitle}</div> : null}
          {this.state.results ? this.renderResults() : this.renderVoteForm()}
        </div>
      </div>
    );
  }
}

const Poll = (props) => {
  const { param1 } = useParams();
  return <PollComponent {...props} pollSlug={param1} />;
};

export default Poll;
